import { connect } from 'react-redux'
import NotFoundComponent from './component'

const NotFoundComponentContainer = connect(
  // Map state to props
)(NotFoundComponent)

export default NotFoundComponentContainer




// WEBPACK FOOTER //
// ./src/views/NotFound/container.js